import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m764-303-57-56 90-121-190-255H331l-79-80h354q19 0 36 9t28 24l190 255q16 20 16 47t-16 47l-96 130Zm-619 78h481L145-706v481Zm0 79q-33 0-56-23t-23-56v-510q0-11 3-21l8-18-88-88q-10-9-10-22 0-14 11-24 10-10 23-10t23 10L902-43q10 10 9 24 0 13-10 23-10 9-23 9t-24-9L670-176q-11 14-27 22t-34 8H145Zm241-320Zm179-82Z"/>',
  f: '<path d="M764-303 252-815h354q19 0 36 9t28 24l190 255q16 21 16 47t-16 47l-96 130ZM145-146q-33 0-56-23t-23-56v-510q0-11 3-21l8-18-88-88q-10-9-10-22 0-14 11-24 10-10 23-10t23 10L902-43q10 10 9 24 0 13-10 23-10 9-23 9t-24-9L670-176q-11 14-27 22t-34 8H145Z"/>',
};

export default data;
